import React from "react";
import { Form, Card, Button } from "react-bootstrap";
import { Search, CurrencyDollar } from "react-bootstrap-icons";
import { Field } from "./Field";
import { CommissionStatus } from "./constants";

// Uncontrolled form: `params` seed the defaults, values are read from FormData
// on submit and handed up via `onSearch`.
export function SearchForm({ params, onSearch, onOpenCalculateBonus }) {
  const { searchTerm, commissionStatus, signedStartDate, signedEndDate } =
    params;

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    onSearch(
      data.get("searchTerm"),
      data.get("status"),
      data.get("signedStartDate"),
      data.get("signedEndDate"),
    );
  };

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Body>
        {/* key remounts the form (and its defaultValues) when the URL changes */}
        <Form
          key={`${searchTerm}|${commissionStatus}|${signedStartDate}|${signedEndDate}`}
          onSubmit={handleSubmit}
        >
          <div className="d-flex flex-wrap align-items-end gap-3">
            <Field label="Signed from">
              <Form.Control
                name="signedStartDate"
                type="date"
                defaultValue={signedStartDate}
              />
            </Field>

            <Field label="Signed to">
              <Form.Control
                name="signedEndDate"
                type="date"
                defaultValue={signedEndDate}
              />
            </Field>

            <Field label="Search">
              <Form.Control
                name="searchTerm"
                type="search"
                placeholder="Contract #, purchaser, agent…"
                defaultValue={searchTerm}
              />
            </Field>

            <Field label="Status">
              <Form.Select name="status" defaultValue={commissionStatus}>
                {Object.values(CommissionStatus).map((status) => (
                    <option key={status} value={status}>
                        {status}
                    </option>
                ))}
                <option value="">All</option>
              </Form.Select>
            </Field>

            <div className="commission-search-actions ms-auto d-flex align-items-center gap-2">
              <Button
                type="button"
                variant="primary"
                size="sm"
                className="d-inline-flex align-items-center gap-1 fw-semibold"
                onClick={onOpenCalculateBonus}
              >
                <CurrencyDollar size={16} />
                Calculate Bonus
              </Button>
              <Button
                type="submit"
                variant="secondary"
                size="sm"
                className="d-inline-flex align-items-center gap-1 fw-semibold"
              >
                <Search size={16} />
                Search
              </Button>
            </div>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}
